import Swal from 'sweetalert2';
import { getAxiosClient } from '~src/api';
import { refreshAiCredits } from '~core/payments';
/**
 * Processes direct invoice payment
 * @param {Array} moduleIds - Array of module IDs
 * @param {string} stripeCustomerId - Stripe customer ID
 * @param {string} paymentMethodId - Selected payment method ID
 * @param {number} totalCredits - Total credits
 * @returns {Promise<Object>} Result with success flag
 */
const processDirectPayment = async (
  moduleIds,
  stripeCustomerId,
  paymentMethodId,
  totalCredits
) => {
  try {
    Swal.fire({
      title: 'Elaborazione del pagamento',
      text: 'Attendere prego...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      showCancelButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const httpClient = await getAxiosClient();
    await httpClient({
      url: `${process.env.USER_API_URL}/stripe/invoice`,
      method: 'POST',
      data: {
        moduleIds,
        stripeCustomerId,
        paymentMethodId,
      },
    });

    await refreshAiCredits(totalCredits);

    return { success: true };
  } catch (error) {
    console.error('Error processing direct payment:', error);
    Swal.fire({
      icon: 'error',
      title: 'Errore nel pagamento',
      text:
        error.message ||
        'Si è verificato un errore durante il pagamento. Verrà utilizzato il metodo di pagamento alternativo.',
      confirmButtonColor: '#278e8e',
    });
    return { success: false };
  }
};

export default processDirectPayment;
